import React, { useState, useEffect } from "react";
import { REGISTER_URL, AUREA_WEBSITE, BRAND } from "@/lib/site";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
    { label: "Outcomes", href: "#outcomes" },
    { label: "Workshops", href: "#workshops" },
    { label: "Schedule", href: "#schedule" },
    { label: "Pricing", href: "#pricing" },
    { label: "Facilitator", href: "#facilitator" },
    { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handler = () => setScrolled(window.scrollY > 8);
        window.addEventListener("scroll", handler);
        return () => window.removeEventListener("scroll", handler);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
                scrolled
                    ? "bg-white/92 backdrop-blur-md border-b border-[color:var(--line)]"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <a
                    href={AUREA_WEBSITE}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="brand-logo"
                    className="flex items-center gap-2 hover:opacity-90 transition-opacity"
                    aria-label={`Visit ${BRAND}`}
                >
                    <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[color:var(--maroon)] text-white font-serif text-sm">
                        A
                    </span>
                    <span className="hidden sm:inline font-mono-label text-slate-500">
                        Organised by {BRAND}
                    </span>
                    <span className="sm:hidden font-mono-label text-slate-500">Aurea</span>
                </a>

                <nav className="hidden md:flex items-center gap-7">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="text-sm text-slate-700 hover:text-[color:var(--maroon)] transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden md:block">
                    <a
                        href={REGISTER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-register-btn"
                        className="btn-maroon inline-flex items-center rounded-full px-5 py-2 text-sm"
                    >
                        Register Now
                    </a>
                </div>

                <button
                    className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-[color:var(--line)] text-slate-700"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Menu"
                    data-testid="mobile-menu-toggle"
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </div>

            {open && (
                <div className="md:hidden bg-white border-t border-[color:var(--line)]">
                    <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-4">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                                className="text-slate-700 py-1"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href={REGISTER_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="mobile-nav-register-btn"
                            className="btn-maroon inline-flex items-center justify-center rounded-full px-5 py-2.5 text-sm"
                        >
                            Register Now
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
